require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./career-initiatives-23.json") })
        }
      }, "path---career-initiatives-23");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---career-initiatives-23!./.cache/json/career-initiatives-23.json
// module id = 1075
// module chunks = 231608221292675